import axios from "axios";
import { Device } from "common/types";
import { alyviaCoreServiceApi } from "utils/constants";

export function getAllActiveDevices(accountId: string): Promise<Device[]> {
  return axios
    .get(`${alyviaCoreServiceApi}/devices/${accountId}/allActive`)
    .then((response) => response.data);
}
